import { Box, Button, Grid, Typography } from '@mui/material';
// import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// import NotFound from '../../../NotFound/NotFound';
import projectData from '../../../../data/projects_data.json';

const ProjectDetail = () => {
  //   const [project, setProject] = useState({});

  let params = useParams();

  const selectedProject = projectData.filter(
    (project) => project.id === params.projectId
  );

  const [project] = selectedProject;

  console.log(project);

  return (
    <Box className="banner-header">
      <Box
        sx={{
          p: { xs: 0, sm: 3, md: 6 },
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            bgcolor: 'white',
            p: { xs: 1, sm: 2, md: 5 },
            mt: 10,
            borderRadius: 4,
            width: { xl: '80%', lg: '90%', md: '100%' },
            mx: 'auto'
          }}
        >
          <Typography variant="h4" sx={{ mb: 5 }}>
            {project?.name}'s Screenshots
          </Typography>
          <Box>
            <Grid container>
              {project?.screenshot?.map((photo) => (
                <Grid
                  key={photo}
                  item
                  xs={12}
                  sm={12}
                  md={3.8}
                  style={{
                    boxShadow: '1px 1px 10px rgba(0, 0, 0, 0.3)',
                    borderRadius: '10px'
                  }}
                  sx={{ m: 1, p: 1 }}
                >
                  <img
                    style={{
                      width: '100%'
                    }}
                    src={photo}
                    alt="screenshot"
                  />
                </Grid>
              ))}
            </Grid>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 10
              }}
            >
              {project?.demo && (
                <a
                  href={project?.demo}
                  style={{ textDecoration: 'none' }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button sx={{ mx: 1 }} variant="contained">
                    Live Demo
                  </Button>
                </a>
              )}
              {project?.clientSide && (
                <a
                  href={project?.clientSide}
                  style={{ textDecoration: 'none' }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button sx={{ mx: 1 }} variant="contained">
                    Client-Side
                  </Button>
                </a>
              )}
              {project?.serverSide && (
                <a
                  href={project?.serverSide}
                  style={{ textDecoration: 'none' }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button sx={{ mx: 1 }} variant="contained">
                    Server-Side
                  </Button>
                </a>
              )}
            </Box>
          </Box>
          <Box sx={{ mt: 5 }}>
            <Box className="banner-header-text">
              <Typography
                fontWeight="bold"
                sx={{
                  textAlign: 'left',
                  fontSize: {
                    xs: '2em',
                    sm: '3em',
                    md: '3.5em'
                  }
                }}
              >
                {project?.name}
              </Typography>
              <Typography variant="h5">{project?.summary}</Typography>

              <>
                {project?.metadata && (
                  <>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 'bold', mt: 5, mb: 1 }}
                    >
                      Meta Data
                    </Typography>
                    <Typography sx={{ fontWeight: 'bold', textAlign: 'left' }}>
                      Client: {project.metadata.client}
                    </Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      Collaborated With: {project.metadata.collaboratedWith}
                    </Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      Duration: {project.metadata.duration}
                    </Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      Role: {project.metadata.role}
                    </Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      Status: {project.metadata.status}
                    </Typography>
                  </>
                )}
              </>

              <Typography sx={{ mt: 1, textAlign: 'left' }}>
                {project?.description}
              </Typography>

              <>
                <Typography variant="h5" sx={{ fontWeight: 'bold', mt: 5 }}>
                  Website Features
                </Typography>
                <Typography sx={{ mt: 1 }}>
                  Here are some of the website features mentioned below.
                </Typography>
                {project.totalFeatures.map((singleFeature, index) => (
                  <Box key={index} sx={{ mt: 2, textAlign: 'left' }}>
                    <Typography variant="h6">{singleFeature.title}</Typography>
                    {singleFeature?.features?.map((feature, index) => (
                      <Typography key={index}>{feature}</Typography>
                    ))}
                  </Box>
                ))}
              </>

              <>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 5 }}>
                  Technologies Used
                </Typography>
                <Box sx={{ mt: 1, textAlign: 'left' }}>
                  {project?.technologies?.map((technology) => (
                    <Typography key={technology}>{technology}</Typography>
                  ))}
                </Box>
              </>
            </Box>
          </Box>
        </Grid>
      </Box>
    </Box>
  );
};

export default ProjectDetail;
